<app-modal
  [title]="'Choose voucher amount' | trans:'vouchers/voucher-amount-picker-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-content-editable-input (valueChange)="amountValue = $event" />

      <div class="d-flex justify-content-flex-end m-t-auto p-t-4">
        <div class="width-fit-content p-4 base-border-radius c-bg-blue-200 p3">
          {{ data.amountMin | numberToCurrency }} {{ languageConfig.currency.short }} - {{ data.amountMax | numberToCurrency }} {{ languageConfig.currency.short }}
        </div>
      </div>
    </div>

    <div class="m-t-24">
      <app-content-box theme="gray">
        <app-keyboard
          [isSimple]="false"
          (clear)="handleKeyboardClear()"
          (deleteBack)="handleKeyboardDeleteBack()"
          (keyClick)="handleKeyboardKeyClick($event)"
        />
      </app-content-box>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'vouchers/voucher-amount-picker-modal/cancel.Button' }}
      </button>
      <button
        #btn
        class="button button--md button--primary text-uppercase"
        [disabled]="isConfirmDisabled"
        (click)="addVoucherToCart(btn)"
      >
        {{ 'Confirm'| trans:'vouchers/voucher-amount-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
